import pkgConfig from '../package.json';

export const BASE_PATH = (pkgConfig as any).homepage || '';

export const HUBSPOT_ID = '6097844';

export const CAPTCHA_SITE_KEY = '6LeFc74ZAAAAAHIs5eVXkIhiDsq1fpZkyKRi0YxP';
